import { CommonModule } from "@angular/common";
import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrl: './status.component.scss',
  standalone: true,
  imports: [CommonModule, TranslateModule]
})

export class StatusComponent implements OnChanges {

  @Input() status!: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.status.toLowerCase() == 'compeleted') this.status = 'Completed'
  }
}